import { render } from "./BreadcrumbComponent.vue?vue&type=template&id=e1e3b6a8"
import script from "./BreadcrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/BreadcrumbComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1e3b6a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1e3b6a8', __exports__)) {
    api.reload('e1e3b6a8', __exports__)
  }
  
  module.hot.accept("./BreadcrumbComponent.vue?vue&type=template&id=e1e3b6a8", () => {
    api.rerender('e1e3b6a8', render)
  })

}


export default __exports__